/* Turqwaz - Logo overlay placement engine
   Moves each .lgo-overlay layer onto the best media / banner container inside
   its OWN section (or onto the whole section) and makes that container the
   positioning context. Safe no-op if nothing suitable is found. */
(function () {
  var MIN_H = 110;
  var MAX_SCAN = 400;

  function box(n) { return n.getBoundingClientRect(); }

  function score(n, rootW) {
    var r = box(n);
    if (r.height < MIN_H) return 0;
    if (r.width < rootW * 0.45) return 0;
    return r.width * r.height;
  }

  /* Real media elements first; if the banner is a CSS background-image instead,
     fall back to scanning for the largest element that paints one. */
  function pickMedia(root) {
    var rootW = root.clientWidth || 1;
    var best = null, bestArea = 0, i, n, a;

    var media = root.querySelectorAll('img, video, iframe');
    for (i = 0; i < media.length; i++) {
      n = media[i];
      if (n.closest && n.closest('.lgo-overlay')) continue;
      a = score(n, rootW);
      if (a > bestArea) { bestArea = a; best = n; }
    }
    if (best) return best;

    var nodes = root.querySelectorAll('div, section, figure, a, span');
    var limit = Math.min(nodes.length, MAX_SCAN);
    for (i = 0; i < limit; i++) {
      n = nodes[i];
      if (n.closest && n.closest('.lgo-overlay')) continue;
      var bg = getComputedStyle(n).backgroundImage;
      if (!bg || bg === 'none' || bg.indexOf('url(') === -1) continue;
      a = score(n, rootW);
      if (a > bestArea) { bestArea = a; best = n; }
    }
    return best;
  }

  /* Climb to the nearest ancestor that can actually act as a positioning
     context: skips <picture>, wrapper links and zero-size / display:contents
     wrappers. */
  function hostFor(media, root) {
    if (media.tagName === 'DIV' || media.tagName === 'SECTION' || media.tagName === 'FIGURE') {
      var mr = box(media);
      if (mr.width > 8 && mr.height > 8) return media;
    }
    var p = media.parentElement;
    while (p && p !== root) {
      var r = box(p);
      if (p.tagName !== 'PICTURE' && p.tagName !== 'A' && r.width > 8 && r.height > 8) return p;
      p = p.parentElement;
    }
    return root;
  }

  function anchorFor(el) {
    var root = el.closest('.shopify-section') || el.parentElement;
    if (!root) return null;
    if (el.getAttribute('data-lgo-anchor') === 'section') return root;
    var media = pickMedia(root);
    if (!media) return root;
    var host = hostFor(media, root);
    var hr = box(host);
    if (hr.width < 8 || hr.height < 8) return root;
    return host;
  }

  /* The anchor must be positioned. The class alone can lose to theme CSS, so
     the inline style is set as well when the element is still static. */
  function makeAnchor(a, force) {
    a.classList.add('lgo-anchor');
    if (force || getComputedStyle(a).position === 'static') {
      a.style.setProperty('position', 'relative', 'important');
    }
  }


  /* Give the box its exact ratio-correct size.
     Sizing purely in CSS breaks down when the box would be taller than the
     section: max-height clips the height but leaves the width alone, so the
     box turns into a letterbox. The logo then sits centred inside that
     letterbox and every placement looks the same. Computing both dimensions
     here keeps the box exactly the shape of the logo (or the chosen ratio),
     so top / middle / bottom stay distinct at any size. */
  function sizeBox(el) {
    var b = el.querySelector('.lgo-box');
    if (!b) return;
    var sw = el.clientWidth, sh = el.clientHeight;
    if (!sw || !sh) return;
    var cs = getComputedStyle(b);
    var pct = parseFloat(cs.getPropertyValue('--lgo-w'));
    var r = parseFloat(cs.getPropertyValue('--lgo-r'));
    if (!(pct > 0)) pct = 100;
    if (!(r > 0)) r = 1;
    var w = Math.min(sw * pct / 100, sh * r);
    var h = w / r;
    b.style.width = w.toFixed(2) + 'px';
    b.style.height = h.toFixed(2) + 'px';
  }
  function place(el, force) {
    if (!force && el.getAttribute('data-lgo-placed') === '1') return;
    var a = anchorFor(el);
    if (!a) return;
    makeAnchor(a);
    if (el.getAttribute('data-lgo-layer') === 'behind') a.classList.add('lgo-iso');
    if (el.parentElement !== a) a.appendChild(el);
    el.setAttribute('data-lgo-placed', '1');
    sizeBox(el);
  }

  /* Late-loading images and sliders can leave a layer in a container that has
     no box yet, or that never became a positioning context. Re-check once
     layout has settled. */
  function verify() {
    var list = document.querySelectorAll('.lgo-overlay[data-lgo-placed="1"]');
    for (var i = 0; i < list.length; i++) {
      var el = list[i];
      var a = el.parentElement;
      if (!a) continue;
      var pr = box(a);
      if (pr.width < 8 || pr.height < 8) { place(el, true); continue; }
      /* The layer must resolve its offsets against the anchor. If some other
         ancestor is acting as the containing block the layer would drift into
         a neighbouring section, so force the anchor to be positioned. */
      if (el.offsetParent !== a) makeAnchor(a, true);
      sizeBox(el);
    }
  }

  function run(scope) {
    var list = (scope || document).querySelectorAll('.lgo-overlay:not([data-lgo-placed="1"])');
    for (var i = 0; i < list.length; i++) place(list[i]);
    verify();
  }

  function boot() { run(); setTimeout(run, 500); setTimeout(run, 1600); setTimeout(run, 3500); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
  window.addEventListener('load', function () { run(); });
  window.addEventListener('resize', function () { clearTimeout(window.__lgoRz); window.__lgoRz = setTimeout(verify, 250); });
  document.addEventListener('shopify:section:load', function (e) { run(e.target); });
  document.addEventListener('shopify:section:reorder', function () { run(); });
  document.addEventListener('shopify:block:select', function () { run(); });
  window.lgoRefresh = run;
})();
